import { _primitive as primitive } from './primitives';

export const _shadows = {
  $1: {
    boxShadow: `0px 1px 1.41px ${primitive.$blackOpacity20}`,
    elevation: 2,
    shadowColor: primitive.$black,
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
  },
} as const;
